export type SectionItem = { slug: string; en: string; zh: string };
export type SectionGroup = { headerEn: string; headerZh: string; items: SectionItem[] };

export const products: SectionItem[] = [
  { slug: "oranhub", en: "OranHub", zh: "OranHub" },
  { slug: "oransim", en: "OranSim", zh: "OranSim" },
  { slug: "orangen", en: "OranGen", zh: "OranGen" },
  { slug: "oranmed", en: "OranMed", zh: "OranMed" },
  { slug: "orangeo", en: "OranGEO", zh: "OranGEO" },
];

export const solutions: SectionGroup[] = [
  {
    headerEn: "Scenario Solutions",
    headerZh: "场景解决方案",
    items: [
      { slug: "geo", en: "GEO", zh: "GEO" },
      { slug: "social-media-marketing", en: "Social Media Marketing", zh: "社媒营销" },
      { slug: "email-marketing", en: "Email Marketing", zh: "邮件营销" },
      { slug: "sales-support", en: "Sales Support", zh: "销售客服" },
    ],
  },
  {
    headerEn: "Industry Solutions",
    headerZh: "行业解决方案",
    items: [
      { slug: "beauty-fmcg", en: "Beauty & FMCG", zh: "美妆快消" },
      { slug: "consumer-electronics", en: "Consumer Electronics", zh: "消费电子" },
      { slug: "cross-border", en: "Cross-border Expansion", zh: "跨境出海" },
      { slug: "data-infrastructure", en: "Data Infrastructure", zh: "数据基建" },
    ],
  },
];
